import { render, staticRenderFns } from "./DeliveryNotesView.vue?vue&type=template&id=dc5e0d48&scoped=true&"
import script from "./DeliveryNotesView.vue?vue&type=script&lang=js&"
export * from "./DeliveryNotesView.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryNotesView.vue?vue&type=style&index=0&id=dc5e0d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5e0d48",
  null
  
)

export default component.exports